import { CDN_BASE_URL, RYC_S3_PUBLIC_URL, SITE_MONITOR_CDN_BASE_URL } from './config';

export function getMediaUrl(path: string | null | undefined): string | undefined {
  if (!path) {
    return undefined;
  }

  // Already a full URL — return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (!CDN_BASE_URL) {
    throw new Error('getMediaUrl: VITE_CDN_BASE_URL is not defined');
  }

  return `${CDN_BASE_URL}${path}`;
}

/**
 * Resolves a site-monitor screenshot key to a public URL. Uses `VITE_SITE_MONITOR_CDN_BASE_URL` when set,
 * otherwise `VITE_CDN_BASE_URL`. Returns undefined (never throws) when neither is set, so a missing
 * config hides the image instead of crashing the report.
 */
export function getSiteMonitorMediaUrl(path: string | null | undefined): string | undefined {
  if (!path) {
    return undefined;
  }

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  const baseUrl = SITE_MONITOR_CDN_BASE_URL || CDN_BASE_URL;
  if (!baseUrl) {
    return undefined;
  }

  return `${baseUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

/** Resolves a bucket key from ryc-site's `/media-uploads` presign flow to a public URL. */
export function getRycWebsiteMediaUrl(path: string | null | undefined): string | undefined {
  if (!path) {
    return undefined;
  }

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (!RYC_S3_PUBLIC_URL) {
    throw new Error('getRycWebsiteMediaUrl: VITE_RYC_S3_PUBLIC_URL is not defined');
  }

  return `${RYC_S3_PUBLIC_URL.replace(/\/$/, '')}/${path}`;
}
